// Varekoden på en vare i pristilbud, pris på ordre og varer fra butikken: EAN (8–14 sifre), PLU
// (kassens egen kode, f.eks. 9960) eller en tekstkode kassa kjenner, f.eks. «PLU SYKKEL»
// (vinnsel, 30.10). Lagres i feltet `ean` (backend godtar fritekst, maks 40 tegn, lib/prislinjer.js).
// Kassa skanner QR-koden på prisoversikten og servicefakturaen; QR lages bare når koden er sifre.

// Det som kan skrives i feltet: bokstaver, sifre, mellomrom og bindestrek, maks 40 tegn.
export const renVarekode = (v) => String(v || '').replace(/[^\p{L}\p{N} -]/gu, '').slice(0, 40);

// Sifrene i koden når den bare er sifre, eventuelt med «PLU»/«EAN» foran («PLU 9960» → «9960»).
// Tekstkoder («PLU SYKKEL») gir ingen sifre.
const bareSifre = (v) => {
  const s = String(v || '').trim();
  return /^(plu|ean)?[\s-]*[\d\s-]+$/i.test(s) ? s.replace(/\D/g, '').slice(0, 14) : '';
};

// Sifrene som kan bli QR-kode: PLU 3–6 eller EAN 8–14 sifre. Ellers tom.
export function varekodeSifre(v) {
  const d = bareSifre(v);
  return (d.length >= 3 && d.length <= 6) || (d.length >= 8 && d.length <= 14) ? d : '';
}

// «PLU 9960», «EAN 7041234567893», eller tekstkoden slik den er skrevet («PLU SYKKEL»).
export function varekodeTekst(v) {
  const d = bareSifre(v);
  if (d) return `${d.length <= 6 ? 'PLU' : 'EAN'} ${d}`;
  return String(v || '').trim().replace(/\s+/g, ' ');
}
